module.exports = __webpack_public_path__ + "img/employeeIdCard.e5d456c2.png";